// import React, { useEffect } from "react";
// import { useMyOrdersQuery } from "../../redux/api/orderApi";
// import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import MetaData from "../layout/MetaData";
// import toast from "react-hot-toast";
// import Loader from "../layout/Loader";
// import { clearCart } from "../../redux/slices/cartSlice";
// import { useDispatch } from "react-redux";

// const MyOrders = () => {
//   const { data, error, isLoading } = useMyOrdersQuery();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const orderSuccess = searchParams.get("order_success");
//   useEffect(() => {
//     if (error) toast.error(error?.data?.message || "Failed to load orders");
//     if (orderSuccess) {
//       dispatch(clearCart());
//       navigate("/me/orders");
//     }
//   }, [error, navigate,dispatch, orderSuccess]);

//   if (isLoading) return <Loader />;

//   return (
//     <>
//       <MetaData title="My Orders - Still&Seen" />

//       <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12 font-sourcesans">
//         <h2 className="text-3xl font-playfair text-yellow-950 mb-8 text-center">
//           My Orders
//         </h2>

//         {data?.orders?.length === 0 ? (
//           <p className="text-center text-stone-600">
//             You don’t have any orders yet.{" "}
//             <Link to="/shop" className="text-amber-700 hover:underline">
//               Go shop
//             </Link>
//           </p>
//         ) : (
//           <div className="overflow-x-auto rounded-md border border-stone-300 bg-white/90">
//             {/* Desktop table */}
//             <table className="hidden md:table w-full text-sm text-stone-700">
//               <thead className="bg-stone-200 text-stone-800 font-medium">
//                 <tr>
//                   <th className="px-4 py-3 text-left">ID</th>
//                   <th className="px-4 py-3 text-left">Amount</th>
//                   <th className="px-4 py-3 text-left">Payment Status</th>
//                   <th className="px-4 py-3 text-left">Order Status</th>
//                   <th className="px-4 py-3 text-left">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data?.orders?.map((order) => (
//                   <tr
//                     key={order._id}
//                     className="border-t border-stone-300 hover:bg-stone-100"
//                   >
//                     <td className="px-4 py-3 font-mono">
//                       {order._id.substring(0, 8)}
//                     </td>
//                     <td className="px-4 py-3 text-yellow-950 font-semibold">
//                       ${order.totalAmount.toFixed(2)}
//                     </td>
//                     <td className="px-4 py-3">
//                       <span
//                         className={`px-2 py-1 text-xs font-medium rounded-md ${
//                           order?.paymentInfo?.status === "succeeded"
//                             ? "bg-green-100 text-green-700"
//                             : "bg-red-100 text-red-700"
//                         }`}
//                       >
//                         {order?.paymentInfo?.status?.toUpperCase()}
//                       </span>
//                     </td>
//                     <td className="px-4 py-3">
//                       <span
//                         className={`px-2 py-1 text-xs font-medium rounded-md ${
//                           order.orderStatus === "Delivered"
//                             ? "bg-green-100 text-green-700"
//                             : "bg-amber-100 text-amber-700"
//                         }`}
//                       >
//                         {order.orderStatus}
//                       </span>
//                     </td>
//                     <td className="px-4 py-3">
//                       <div className="flex gap-2">
//                         <Link
//                           to={`/me/order/${order._id}`}
//                           className="px-3 py-1 text-xs rounded-md bg-amber-700 text-white hover:bg-amber-800"
//                         >
//                           View
//                         </Link>
//                         <Link
//                           to={`/receipt/order/${order._id}`}
//                           className="px-3 py-1 text-xs rounded-md bg-stone-700 text-white hover:bg-stone-800"
//                         >
//                           Receipt
//                         </Link>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Mobile cards */}
//             <div className="grid gap-4 p-4 md:hidden">
//               {data?.orders?.map((order) => (
//                 <div
//                   key={order._id}
//                   className="bg-white rounded-md shadow-sm border border-stone-300 p-4"
//                 >
//                   <div className="flex justify-between items-center mb-2">
//                     <h3 className="font-playfair text-yellow-950">
//                       #{order._id.substring(0, 8)}
//                     </h3>
//                     <span
//                       className={`px-2 py-1 text-xs font-medium rounded-md ${
//                         order.orderStatus === "Delivered"
//                           ? "bg-green-100 text-green-700"
//                           : "bg-amber-100 text-amber-700"
//                       }`}
//                     >
//                       {order.orderStatus}
//                     </span>
//                   </div>
//                   <p className="text-yellow-950 font-semibold">
//                     ${order.totalAmount.toFixed(2)}
//                   </p>
//                   <p className="mt-1">
//                     <span
//                       className={`px-2 py-1 text-xs font-medium rounded-md ${
//                         order?.paymentInfo?.status === "succeeded"
//                           ? "bg-green-100 text-green-700"
//                           : "bg-red-100 text-red-700"
//                       }`}
//                     >
//                       {order?.paymentInfo?.status?.toUpperCase()}
//                     </span>
//                   </p>
//                   <div className="flex gap-2 mt-3">
//                     <Link
//                       to={`/me/order/${order._id}`}
//                       className="flex-1 text-center px-3 py-1 text-xs rounded-md bg-amber-700 text-white hover:bg-amber-800"
//                     >
//                       View
//                     </Link>
//                     <Link
//                       to={`/receipt/order/${order._id}`}
//                       className="flex-1 text-center px-3 py-1 text-xs rounded-md bg-stone-700 text-white hover:bg-stone-800"
//                     >
//                       Receipt
//                     </Link>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default MyOrders;

import React, { useEffect } from "react";
import { useMyOrdersQuery } from "../../redux/api/orderApi";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import toast from "react-hot-toast";
import Loader from "../layout/Loader";
import { clearCart } from "../../redux/slices/cartSlice";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";

const MyOrders = () => {
  const { data, error, isLoading } = useMyOrdersQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderSuccess = searchParams.get("order_success");

  useEffect(() => {
    if (error) toast.error(error?.data?.message || "Failed to load orders");
    if (orderSuccess) {
      dispatch(clearCart());
      navigate("/me/orders");
    }
  }, [error, navigate, dispatch, orderSuccess]);

  if (isLoading) return <Loader />;

  return (
    <>
       <Helmet>
        <title>My Orders</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="max-w-6xl mt-20 md:mt-48 mx-auto px-4 sm:px-6 py-12 font-sourcesans">
        <h2 className="text-3xl md:text-4xl font-playfair text-[#BC3F4A] mb-10 text-center">
          My Orders
        </h2>

        {data?.orders?.length === 0 ? (
          <p className="text-center text-stone-600">
            You don’t have any orders yet.{" "}
            <Link
              to="/shop"
              className="text-[#BC3F4A] font-medium hover:underline"
            >
              Go shop
            </Link>
          </p>
        ) : (
          <div className="overflow-hidden rounded-lg  border border-[#8a4b32]/30 bg-white/80 shadow-sm">
            {/* Desktop table */}
            <table className="hidden md:table w-full text-sm text-stone-700">
              <thead className="bg-[#f5f3ea] text-stone-800 font-medium">
                <tr>
                  <th className="px-5 py-3 text-left">Order ID</th>
                  <th className="px-5 py-3 text-left">Amount</th>
                  <th className="px-5 py-3 text-left">Payment</th>
                  <th className="px-5 py-3 text-left">Status</th>
                  <th className="px-5 py-3 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data?.orders?.map((order) => (
                  <tr
                    key={order._id}
                    className="border-t border-[#8a4b32]/20 hover:bg-[#fdfcf8]"
                  >
                    <td className="px-5 py-3 font-mono text-sm text-stone-800">
                      {order._id.substring(0, 8)}
                    </td>
                    <td className="px-5 py-3 text-[#1c1917] font-semibold">
                      ${order.totalAmount.toFixed(2)}
                    </td>
                    <td className="px-5 py-3">
                      <span
                        className={`px-2 py-1 text-xs font-medium rounded-md ${
                          order?.paymentInfo?.status === "paid"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {order?.paymentInfo?.status?.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-5 py-3">
                      <span
                        className={`px-2 py-1 text-xs font-medium rounded-md ${
                          order.orderStatus === "Delivered"
                            ? "bg-green-100 text-green-700"
                            : "bg-amber-100 text-amber-700"
                        }`}
                      >
                        {order.orderStatus}
                      </span>
                    </td>
                    <td className="px-5 py-3">
                      <div className="flex gap-2">
                        <Link
                          to={`/me/order/${order._id}`}
                          className="px-3 py-1 text-xs rounded-md bg-[#BC3F4A] text-white hover:bg-[#a3323b] transition"
                        >
                          View
                        </Link>
                        <Link
                          to={`/receipt/order/${order._id}`}
                          className="px-3 py-1 text-xs rounded-md bg-stone-700 text-white hover:bg-stone-800 transition"
                        >
                          Receipt
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Mobile cards */}
            <div className="grid gap-4 p-4 md:hidden">
              {data?.orders?.map((order) => (
                <div
                  key={order._id}
                  className="bg-white rounded-md shadow-sm border border-[#8a4b32]/20 p-4"
                >
                  <div className="flex justify-between items-center mb-2">
                    <h3 className="font-playfair text-[#BC3F4A]">
                      #{order._id.substring(0, 8)}
                    </h3>
                    <span
                      className={`px-2 py-1 text-xs font-medium rounded-md ${
                        order.orderStatus === "Delivered"
                          ? "bg-green-100 text-green-700"
                          : "bg-amber-100 text-amber-700"
                      }`}
                    >
                      {order.orderStatus}
                    </span>
                  </div>
                  <p className="text-[#1c1917] font-semibold">
                    ${order.totalAmount.toFixed(2)}
                  </p>
                  <p className="mt-1">
                    <span
                      className={`px-2 py-1 text-xs font-medium rounded-md ${
                        order?.paymentInfo?.status === "paid"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {order?.paymentInfo?.status?.toUpperCase()}
                    </span>
                  </p>
                  <div className="flex gap-2 mt-3">
                    <Link
                      to={`/me/order/${order._id}`}
                      className="flex-1 text-center px-3 py-1 text-xs rounded-md bg-[#BC3F4A] text-white hover:bg-[#a3323b] transition"
                    >
                      View
                    </Link>
                    <Link
                      to={`/receipt/order/${order._id}`}
                      className="flex-1 text-center px-3 py-1 text-xs rounded-md bg-stone-700 text-white hover:bg-stone-800 transition"
                    >
                      Receipt
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default MyOrders;


